import * as angular from "angular";
import {IController} from "angular";

export class AccountVehiclesListCtrl implements IController {

  vehicles: any;
  loading: any;

  updateActiveState: Function;
  selectVehicle: Function;
  addNewVehicle: Function;
  removeVehicle: Function;
}

angular
  .module('bringoz.admin.accounts')
  .component('accountVehiclesList', {
    bindings: {
      vehicles: '<',
      loading: '<?',
      updateActiveState: '&',
      selectVehicle: '&',
      addNewVehicle: '&',
      removeVehicle: '&'
    },
    template: require('./account-vehicles-list.html').default,
    controller: AccountVehiclesListCtrl
  });
